import React, {Component} from 'react';
import PropTypes from 'prop-types';
import IconSize from '../../helpers/IconSize';
import './DestinationMessage.less';
import {getIconProps} from '../../helpers/helpers';


class DestinationMessage extends Component {
    static propTypes = {
        /** Optional classname to override the root styling */
        className: PropTypes.string,
        /** Sets size and behavior of font and icon */
        size: PropTypes.string,
        /** Data to use in rendering component */
        destinationMessage: PropTypes.oneOfType([
            PropTypes.shape({
                iconTitleTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string
                })
            }),
            PropTypes.shape({
                iconTitleTextV3: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string
                })
            }),
            PropTypes.shape({
                iconTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string
                })
            })
        ]),
        color: PropTypes.bool
    };

    static defaultProps = {
        className: '',
        size: IconSize.MEDIUM,
        destinationMessage: {},
        color: false
    };

    render() {
        const {className, size, destinationMessage, color} = this.props;

        if (!destinationMessage || !destinationMessage.iconTitleTextV1
            && !destinationMessage.iconTitleTextV3
            && !destinationMessage.iconTextV1) {
            return null;
        }

        let icon;
        let message;
        let title;

        if (destinationMessage.iconTextV1) {
            ({icon, message} = destinationMessage.iconTextV1);
        } else if (destinationMessage.iconTitleTextV1) {
            ({icon, message, title} = destinationMessage.iconTitleTextV1);
        } else if (destinationMessage.iconTitleTextV3) {
            ({icon, message, title} = destinationMessage.iconTitleTextV3);
        }

        const {style, src} = getIconProps(icon, size, color);
        const smallPrefix = size === IconSize.SMALL ? '--s' : '';

        return (
            <div className={`DestinationMessage ${className}`}>
                <img style={style} src={typeof src === 'function' ? src() : src} alt={icon}/>
                <div className={`DestinationMessage__message${smallPrefix}`}>
                    {
                        title &&
                        <span className={`DestinationMessage__message${smallPrefix}__title`}><strong>{title}</strong></span>
                    }
                    <span className={`DestinationMessage__message${smallPrefix}__text`}>
                        {message}
                    </span>
                </div>
            </div>
        );
    }
}

export default DestinationMessage;
